import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';
import { UnitItemUpdatePostState } from 'common-ts/dist/models/UnitItem';
import { fetchUnitItemsList } from "./UnitItemListPostRedux";

const initialState: UnitItemUpdatePostState = {
    unitItemDraft: {
        unitItemId: '',
        reorderTriggerAmount: 0,
        reorderPurchaseAmount: 0,
        restockPriority: 3,
        isRestockable: false,
    },

    dialogOpen: false,

    status: APIRequestStatus.Idle,
    error: ''
}

const slice = createSlice({
    name: 'unitItemUpdate',
    initialState,
    reducers: {
        updateVal(state, action) {
          state.unitItemDraft = action.payload;
          console.log(`State values: ${JSON.stringify(state.unitItemDraft)}`);
        },
        updateDialogOpen(state, action) {
          state.dialogOpen = action.payload;
        }
    },
    extraReducers(builder) {
        builder
          .addCase(postUpdateUnitItem.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postUpdateUnitItem.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postUpdateUnitItem.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
      }
})

export const postUpdateUnitItem = createAsyncThunk('unitItemUpdate/postUpdateUnitItem', async (arg, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'put',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/unititem',
      data: state.unitItemUpdate.unitItemDraft,
    });

    thunkAPI.dispatch(fetchUnitItemsList());

    return response.data
})

export const { updateVal, updateDialogOpen } = slice.actions

export default slice.reducer